/**
 * Eén publiek adres per installatie (`PUBLIC_ORIGIN`, gekozen bij
 * `ae-install`). Opent iemand de web-app op een ander adres — het oude
 * `*.netlify.app` na een eigen domein — dan sturen we door, met pad en al.
 * Alleen de pagina zelf: API-aanroepen en Claude-connectors op het oude adres
 * blijven werken. Lokaal (localhost, `.local` voor de iPad) nooit.
 */
import { fetchServerVersion } from "./buildInfo";

interface Here {
  origin: string;
  hostname: string;
  pathname: string;
  search: string;
  hash: string;
}

const LOCAL = /^(localhost|127\.0\.0\.1|\[::1\])$|\.local$/;

/** Het adres om naar door te sturen, of `null` als dit al het goede is. */
export function canonicalRedirect(here: Here, publicOrigin: string | null): string | null {
  if (!publicOrigin || LOCAL.test(here.hostname)) return null;
  let target: URL;
  try {
    target = new URL(publicOrigin);
  } catch {
    return null;
  }
  if (target.protocol !== "https:" || target.origin === here.origin) return null;
  return `${target.origin}${here.pathname}${here.search}${here.hash}`;
}

/** Vraagt de server om het publieke adres en stuurt zo nodig door. */
export async function redirectToPublicOrigin(): Promise<void> {
  const server = await fetchServerVersion();
  const target = canonicalRedirect(window.location, server?.public_origin ?? null);
  if (target) window.location.replace(target);
}
